import ApiService from "./ApiService"

export default {
    search(search) {
         let params = new URLSearchParams();
         if(search.output)
             params.append('output', search.output);
         if(search.startDate && search.startDate.length > 0)
             params.append('startDate', search.startDate);
        if(search.endDate && search.endDate.length > 0)
             params.append('endDate', search.endDate);
        if(search.search && search.search.length > 0)
             params.append('term', search.search);
        if(search.companyId && search.companyId > 0)
             params.append('companyId', search.companyId);
        if(search.memberId && search.memberId > 0)
             params.append('memberId', search.memberId);
        if(search.projectId && search.projectId > 0)
             params.append('projectId', search.projectId);
        if(search.orderBy)
             params.append('orderBy', search.orderBy);

         let qs = params.toString();
         if(qs && qs.length > 0)
             qs = "?" + qs;
        return ApiService().get(`api/reports/${search.offset}/${search.limit}${qs}`);
    },
    get(id) {
        return ApiService().get(`api/reports/${id}`);
    },
    put(id, payload) {
        return ApiService().put(`api/reports/${id}`, payload);
    },
    post(payload) {
        return ApiService().post(`api/reports`, payload);
    },
    delete(reportId) {
        return ApiService().delete(`api/reports/${reportId}`, {});
    },
    export(payload) {
        return ApiService().post(`api/report-export/`, payload);
    },
    exportStatus(processId) {
        return ApiService().get(`api/report-export/${processId}`);
    },
    exportDownload(processId, ext) {
        return ApiService().get(`api/report-export.${ext}/${processId}`, { responseType: 'blob', timeout: 30000 });
    }
}